import { useLanguage } from '../context/LanguageContext'
import type { Language } from '../i18n/translations'

export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage()

  const handleChange = (newLang: Language) => {
    setLanguage(newLang)
  }

  return (
    <div className="fixed top-4 right-4 z-40">
      <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-white/90 backdrop-blur-sm shadow-lg">
        <button
          onClick={() => handleChange('en')}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all flex items-center gap-1.5 ${
            language === 'en'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
        >
          <span className="text-base">🇬🇧</span>
          EN
        </button>
        <button
          onClick={() => handleChange('nl')}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all flex items-center gap-1.5 ${
            language === 'nl'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
        >
          <span className="text-base">🇳🇱</span>
          NL
        </button>
      </div>
    </div>
  )
}
